const BASE_OPTIONS = {
  fullScreen: { enable: false },
  detectRetina: false,
  fpsLimit: 24,
  interactivity: {
    events: {
      onClick: { enable: false },
      onHover: { enable: false },
      resize: true
    }
  },
  particles: {
    number: { value: 28, density: { enable: true, area: 900 } },
    opacity: {
      value: 0.25,
      animation: { enable: false }
    },
    move: {
      enable: true,
      speed: 0.35,
      direction: 'none',
      outModes: { default: 'out' }
    },
    size: {
      value: { min: 1, max: 2.5 },
      animation: { enable: false }
    }
  }
};

const THEME_PARTICLE_OPTIONS = {
  navy: {
    particles: {
      color: { value: ['#5d7fb1', '#2d3a5b'] },
      shape: { type: 'circle' },
      number: { value: 32 },
      opacity: { value: 0.45 },
      size: { value: { min: 1.2, max: 2.6 } },
      move: { speed: 0.25 }
    }
  },
  sage: {
    particles: {
      color: { value: ['#8e9cab', '#b6c9b8'] },
      shape: { type: 'circle' },
      number: { value: 20 },
      opacity: { value: 0.22 },
      size: { value: { min: 2, max: 5 } },
      move: { speed: 0.18 }
    }
  },
  'charcoal-noir': {
    particles: {
      color: { value: ['#8593a0', '#d2dae2'] },
      links: {
        enable: true,
        color: '#8593a0',
        distance: 120,
        opacity: 0.15,
        width: 1
      },
      shape: { type: 'circle' },
      number: { value: 24 },
      opacity: { value: 0.2 },
      size: { value: { min: 1, max: 2 } },
      move: { speed: 0.22 }
    }
  },
  cyberpunk: {
    particles: {
      color: { value: '#8593a0' },
      shape: { type: 'circle' },
      number: { value: 120 },
      opacity: { value: 0.8 },
      size: { value: { min: 1.5, max: 3 } },
      move: { speed: 0.8, direction: 'none', random: true, outModes: { default: 'out' } },
      links: {
        enable: true,
        distance: 150,
        color: '#00f5d4',
        opacity: 0.6,
        width: 0.8
      }
    }
  },
  'nostalgic-wood': {
    particles: {
      color: { value: ['#d9ab7a', '#f3e0c9'] },
      shape: { type: 'circle' },
      number: { value: 18 },
      opacity: { value: 0.18 },
      size: { value: { min: 1, max: 3.8 } },
      move: { speed: 0.14 }
    }
  },
  'rainy-gloom': {
    particles: {
      color: { value: ['#8ec4ff', '#5da3ff'] },
      shape: { type: 'line' },
      number: { value: 150, density: { enable: true, area: 1400 } },
      opacity: { value: 0.9 },
      size: { value: { min: 5, max: 5} },
      rotate: {
        value: 90,
        animation: { enable: false }
      },
      move: {
        speed: 8,
        direction: 'bottom',
        angle: { value: 20 },
        straight: true,
        outModes: { default: 'out' }
      },
      stroke: { width: 3, color: '#8ec4ff' }
    }
  },
  'power-surge': {
    particles: {
      number: {
        value: 200,
        density: {
          enable: true
        }
      },
      color: {
        value: ['#fdcf58', '#757676', '#f27d0c', '#800909', '#f07f13']
      },
      opacity: {
        value: { min: 0.1, max: 0.5 }
      },
      size: {
        value: { min: 1, max: 3 }
      },
      move: {
        enable: true,
        speed: 6,
        random: false
      }
    }
  },
  'grand-prix': {
    particles: {
      color: { value: ['#ffffff', '#f3d447', '#d90f23'] },
      shape: { type: 'line' },
      number: { value: 56, density: { enable: true, area: 900 } },
      opacity: { value: { min: 0.22, max: 0.58 } },
      size: { value: { min: 4, max: 13 } },
      rotate: {
        value: { min: 84, max: 96 },
        animation: { enable: false }
      },
      move: {
        enable: true,
        speed: 6.8,
        direction: 'right',
        straight: true,
        random: false,
        outModes: { default: 'out' }
      },
      stroke: { width: 2, color: '#f5f7fb' }
    }
  },
  'sunshine-rainbows': {
    particles: {
      color: { value: ['#ffd95a', '#9ed8ff', '#ff9ac8', '#67bdf5'] },
      shape: { type: 'circle' },
      number: { value: 24 },
      opacity: { value: 0.3 },
      size: { value: { min: 2, max: 4.2 } },
      move: { speed: 0.35 }
    }
  },
  'winter-snow': {
    preset: 'snow',
    particles: {
      color: { value: ['#ffffff', '#e8f4ff', '#d7ebff'] },
      number: { value: 80, density: { enable: true, area: 900 } },
      opacity: { value: { min: 0.35, max: 0.85 } },
      size: { value: { min: 1.5, max: 4.5 } },
      move: { speed: 0.9 }
    }
  },
  'back-alley-smoke': {
    particles: {
      color: { value: ['#b8bec8', '#9098a4', '#6d747f'] },
      shape: { type: 'circle' },
      number: { value: 34, density: { enable: true, area: 1300 } },
      opacity: { value: { min: 0.08, max: 0.22 } },
      size: { value: { min: 3, max: 9 } },
      move: {
        enable: true,
        speed: 0.2,
        direction: 'top-right',
        random: true,
        outModes: { default: 'out' }
      }
    }
  },
  'noir-rb': {
    particles: {
      color: { value: ['#8e2de2', '#ff4f9d', '#ab0458'] },
      shape: { type: 'circle' },
      number: { value: 32, density: { enable: true, area: 1200 } },
      opacity: { value: 0.28 },
      size: { value: { min: 1.5, max: 3.5 } },
      move: { speed: 0.45, direction: 'none', random: true, outModes: { default: 'out' } }
    }
  },
  'pre-dawn': {
    particles: {
      color: { value: ['#9fb7ff', '#a78be4', '#d1d9ff'] },
      shape: { type: 'circle' },
      number: { value: 28, density: { enable: true, area: 1300 } },
      opacity: { value: 0.18 },
      size: { value: { min: 1, max: 2.5 } },
      move: { speed: 0.25, direction: 'none', random: true, outModes: { default: 'out' } }
    }
  }
  ,
  'dream-love': {
    particles: {
      color: { value: ['#f6c5ff', '#ffd3f4', '#ff92c7'] },
      shape: { type: 'circle' },
      number: { value: 30, density: { enable: true, area: 1000 } },
      opacity: { value: 0.32 },
      size: { value: { min: 1.8, max: 3.6 } },
      move: { speed: 0.35, random: true, outModes: { default: 'out' } }
    }
  }
  ,
  'forest-green': {
    particles: {
      color: { value: ['#7aa07f', '#4b6f58', '#92bdb3'] },
      shape: { type: 'circle' },
      number: { value: 36, density: { enable: true, area: 1400 } },
      opacity: { value: 0.2 },
      size: { value: { min: 1.2, max: 2.4 } },
      move: { speed: 0.28, direction: 'none', random: true, outModes: { default: 'out' } }
    }
  }
};

function mergeOptions(base, overrides) {
  const result = { ...base };
  Object.entries(overrides || {}).forEach(([key, value]) => {
    if (value && typeof value === 'object' && !Array.isArray(value)) {
      result[key] = mergeOptions(base[key] || {}, value);
      return;
    }
    result[key] = value;
  });
  return result;
}

export function getThemeParticlesOptions(paletteId) {
  const themeOptions = THEME_PARTICLE_OPTIONS[paletteId] || THEME_PARTICLE_OPTIONS.navy;
  return mergeOptions(BASE_OPTIONS, themeOptions);
}

export function getLocalCdParticleOptions(paletteId) {
  const baseOptions = getThemeParticlesOptions(paletteId);
  return mergeOptions(baseOptions, {
    particles: {
      shape: { type: 'square' },
      size: { value: { min: 2, max: 4 } },
      opacity: { value: { min: 0.35, max: 0.8 } },
      move: {
        speed: 0.9,
        trail: { fillColor: '#000000' },
        outModes: { default: 'bounce' },
        direction: 'none',
        random: true,
      },
      number: { value: 48 },
    },
  });
}
